import { h } from 'preact'
import StatusCircle from '../../ui-components/StatusCircle'

const StatusCell = () => {
  return ({ status }: { status: string }) => {
    status = status.toLowerCase()
    const variant = status === 'sent' ? 'published' : status

    return (
      <div className='overview__status'>
        <StatusCircle variant={variant} />
        { status.charAt(0).toUpperCase() + status.slice(1) }
      </div>
    )
  }
}

export default StatusCell
